import { render, staticRenderFns } from "./DropzoneStyled.vue?vue&type=template&id=139c82f8"
import script from "./DropzoneStyled.vue?vue&type=script&lang=js"
export * from "./DropzoneStyled.vue?vue&type=script&lang=js"
import style0 from "./DropzoneStyled.vue?vue&type=style&index=0&id=139c82f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports